'use strict';

bbw.directive.bbwScrollHere = function() {
    return {
        link: function(scope, element, attrs) {
            var timeout = null;

            function scrollToElement() {
                element[0].scrollIntoViewIfNeeded();
            }

            function update() {
                if (attrs.bbwScrollHere) {
                    if (!timeout) {
                        timeout = setTimeout(function() {
                            timeout = null;
                            scrollToElement();
                        }, 100);
                    }
                }
            }
            attrs.$observe('bbwScrollHere', update);

            update();
        }
    };
};
